import React, { Component } from 'react';

import { Modal } from 'react-bootstrap';
import ScheduledEvents from './ScheduledEvents';
import InfoTooltipIcon from '../../assets/InfoTooltipIcon';

const daysOfWeek = {
  Monday: 'Mon',
  Tuesday: 'Tue',
  Wednesday: 'Wed',
  Thursday: 'Thu',
  Friday: 'Fri',
  Saturday: 'Sat',
  Sunday: 'Sun',
};
export default class DisplayRowStockingSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleLocalChange = this.handleLocalChange.bind(this);
  }

  handleLocalChange(event) {
    const targetData = {
      target: {
        name: event.target.name,
        value: event.target.checked === true ? 1 : 0,
      },
    };
    console.log(targetData);
    return targetData;
  }

  render() {
    return (
      <tr>
        <td>
          {this.props.prettyName}
          {this.props.tooltip ? (
            <InfoTooltipIcon tooltipText={this.props.tooltip} />
          ) : (
            ''
          )}
        </td>
        <td className="detailColumn" onClick={this.props.handleOpen}>
          {this.props.value.Mon === 1 && <span> Monday;</span>}
          {this.props.value.Tue === 1 && <span> Tuesday;</span>}
          {this.props.value.Wed === 1 && <span> Wednesday;</span>}
          {this.props.value.Thu === 1 && <span> Thursday;</span>}
          {this.props.value.Fri === 1 && <span> Friday;</span>}
          {this.props.value.Sat === 1 && <span> Saturday;</span>}
          {this.props.value.Sun === 1 && <span> Sunday;</span>}
        </td>
        <Modal show={this.props.edit}>
          <Modal.Header>
            <Modal.Title>Stocking Schedule</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table>
              <tbody>
                {Object.keys(daysOfWeek).map((day) => (
                  <tr key={day}>
                    <td>
                      <label>{day}</label>
                    </td>
                    <td>
                      <input
                        name={daysOfWeek[day]}
                        type="checkbox"
                        checked={this.props.value[daysOfWeek[day]] === 1}
                        onChange={(value) => {
                          this.props.handleChange(
                            this.handleLocalChange(value),
                          );
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <ScheduledEvents
              events={this.props.events}
              id={this.props.id}
              deleteScheduleAction={this.props.deleteScheduleAction}
            />
          </Modal.Body>
          <Modal.Footer>
            &nbsp;
            <button
              onClick={this.props.handleClose}
              type="button"
              className="btn modalButtons btn-primary"
            >
              Close
            </button>
            <button
              onClick={this.props.handleSave}
              type="button"
              className="btn modalButtons btn-success"
            >
              Save
            </button>
            <button
              onClick={this.props.handleSchedule}
              type="button"
              className="btn modalButtons success"
            >
              Schedule
            </button>
          </Modal.Footer>
        </Modal>
      </tr>
    );
  }
}
